import { render, staticRenderFns } from "./PointControl.vue?vue&type=template&id=4cad9fa4&scoped=true&"
import script from "./PointControl.vue?vue&type=script&lang=js&"
export * from "./PointControl.vue?vue&type=script&lang=js&"
import style0 from "./PointControl.vue?vue&type=style&index=0&id=4cad9fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad9fa4",
  null
  
)

export default component.exports